"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CloseOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var CloseOutlineSVG = function CloseOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M17.41 16l12.3-12.29a1 1 0 10-1.42-1.42L16 14.59 3.71 2.29a1 1 0 00-1.42 1.42L14.59 16 2.29 28.29a1 1 0 000 1.42 1 1 0 001.42 0L16 17.41l12.29 12.3a1 1 0 001.42 0 1 1 0 000-1.42z"
  }));
};
exports.CloseOutlineSVG = CloseOutlineSVG;
CloseOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CloseOutlineSVG);
exports.default = _default;